import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { useJobTitle, useUpdateJobTitle } from "../hooks";
import { JobTitleForm } from "../components";

type IUpdateJobTitle = {
  id: string;
};

export const UpdateJobTitle: React.FC = () => {
  const { id } = useParams<IUpdateJobTitle>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useJobTitle(+id!);
  const { form, submit, loading } = useUpdateJobTitle({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("L'intitulé de poste a été modifié avec succès");
    },
  });

  useEffect(() => {
    if (data?.jobTitle?.ok && data?.jobTitle?.result) {
      const { result } = data.jobTitle;
      form.setValue("name", result.name);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  return (
    <>
      <Header
        title="Intitulé de poste"
        subtitle={data?.jobTitle?.result?.name}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/job-titles`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier un intitulé de poste" />
          <JobTitleForm loading={loading} form={form} submit={submit} />
        </div>
      </div>
    </>
  );
};
